<template>
    <div>

      <div>
        <p>
          <span>
            Please enter the login code to validate your new contact information. Login code will be valid for limited time. 
            If you entered email and cell phone # you will have received separate login code(s) and you will have to validate both. 
            After validating both click 'Next' to navigate to your RI DMV Online Customer profile.
          </span> <br />
          <span>
            Your contact information will be saved against your RI record and used for future electronic Multi Factor Authentication (MFA). 
          </span>
        </p>
        <p class="err-email" v-if="contactMfaRequestEmail.length>0 && !contactMfaRequestEmail[0].isSucess">
          Unable to send login code to provided email
        </p>
        <div class="user-con-validate" v-if="updateContact.email">

          <div class="user-con-details">
            <div class="user-details" >
              <label>Email</label> 
              <div class="verify-updateContact">
                <label for="email">{{updateContactInfo.email}}</label>   
                <img v-if="contactVerifyEmail" class="verify-icon" src="static/verified-icon.png" alt="Email is verified">
              </div>
            </div>
            <div class="user-details" v-if="!contactVerifyEmail">
              <div>
                <label class="login-code-text">Login code</label>
                <input type="text" v-model="otpEmail" maxlength="12"> 
                <p v-if="errEmail" class="err-msg">{{ errEmail }}</p>
              </div>
            </div>
          </div>
          <div class="user-response" v-if="!contactVerifyEmail">
            <div class="btn-otp">
              <!-- <button @click="validateOtp('Email')" class="app-btn-primary">Validate login code</button>
              <button @click="resendOtp('Email')">Resend login code</button> -->

              <CustomButton @click="validateOtp('Email')">Validate login code</CustomButton>
              <CustomButton @click="resendOtp('Email')" class="resend-code">Resend login code</CustomButton>
            </div>   
          </div>
        </div>

        <p v-if="contactMfaRequestPhone.length>0 && !contactMfaRequestPhone[0].isSucess" class="err-phone">
          Unable to send login code to provided phone
        </p>
        <div class="user-con-validate" v-if="updateContact.phone">

          <div class="user-con-details">
            <div class="user-details">
              <div class="user-phone-details">
                <label>Phone </label>
                <span class="user-phone-text">(Message and data rates may apply)</span>
              </div>
              <div class="verify-updateContact">
                <label for="phone">{{ updateContactInfo.phone }}</label> 
                <img v-if="contactVerifyPhone" class="verify-icon" src="static/verified-icon.png" alt="Phone is verified">
              </div>
            </div>                
            <div class="user-details" v-if="!contactVerifyPhone">
              <div>
                <label class="login-code-text">Login code</label>
                <input type="text" v-model="otpPhone" maxlength="12">  
                <p v-if="errPhone" class="err-msg">{{ errPhone }}</p>
              </div>
            </div>
          </div>
          <div class="user-response" v-if="!contactVerifyPhone">
            <div class="btn-otp">
              <!-- <button @click="validateOtp('Phone')" class="app-btn-primary">Validate login code</button>
              <button @click="resendOtp('Phone')">Resend login code</button> -->

              <CustomButton @click="validateOtp('Phone')">Validate login code</CustomButton>
              <CustomButton @click="resendOtp('Phone')" class="resend-code">Resend login code</CustomButton>
            </div>  
          </div>
        </div>
      </div>
  
      <BaseButtonGroup>
        <button type="button" @click="handleRouting('previous')">Previous</button>
        <button type="submit" class="app-btn-primary" @click.prevent="handleRouting('next')" :disabled="!btnDisable">
          Next
        </button>
      </BaseButtonGroup>
    </div>
</template>


<script>
import * as COMMONS from '../../store/_commons';
import { mapGetters,mapActions,mapState } from 'vuex';
import BaseButtonGroup from '@/components/ui/BaseButtonGroup';
import { phoneMixin } from '@/utils/phoneMixin';
import CustomButton from '../CustomButton.vue';

export default {
  name: 'MFA',
  components: {
    BaseButtonGroup,
    CustomButton
  },
  data() {
    return {
      screenData: {},
      otpPhone: '',
      otpEmail: '',
      errEmail: '',
      errPhone: '',
      emailCount: 0,
      phoneCount: 0
    }
  },
  mixins: [
    phoneMixin,
  ],
  computed: {
    ...mapGetters({
      personalInfo: COMMONS.GUEST_PERSONAL_INFO,
    }),
    ...mapState([
      'networkResponse',
    ]),
    contactInfo() {
      return this.$store.state.guestLogin.loginUserDetails;
    },
    updateContact() {
      return this.$store.state.guestLogin.updateContact;
    },
    updateContactInfo() {
      return this.$store.state.guestLogin.contactUpdateInfo;
    },
    contactVerifyEmail() {
      return this.$store.state.guestLogin.contactVerifyEmail;
    },
    contactVerifyPhone() {
      return this.$store.state.guestLogin.contactVerifyPhone;
    },
    contactMfaRequestPhone() {
      return this.$store.state.guestLogin.contactMfaRequest.responses && this.$store.state.guestLogin.contactMfaRequest.responses.filter(item => item.mfaType == 1);
    },
    contactMfaRequestEmail() {
      return this.$store.state.guestLogin.contactMfaRequest.responses && this.$store.state.guestLogin.contactMfaRequest.responses.filter(item => item.mfaType == 2);
    },
    btnDisable() {
      if(this.updateContactInfo.email && !this.updateContactInfo.phone){
        return this.contactVerifyEmail;
      }
      if(!this.updateContactInfo.email && this.updateContactInfo.phone){
        return this.contactVerifyPhone;
      }
      if(this.updateContactInfo.email && this.updateContactInfo.phone){
        if(this.contactMfaRequestPhone && !this.contactMfaRequestPhone[0].isSucess ) {
          return this.contactVerifyEmail;
        }
        if(this.contactMfaRequestEmail && !this.contactMfaRequestEmail[0].isSucess ) {
          return this.contactVerifyPhone;
        } 
        else {
          return this.contactVerifyPhone && this.contactVerifyEmail;
        }
      }
      else {
        return false;
      }
    }
  },
  created() {

  },
  mounted() {
    window.scroll(0,0);
    document.body.setAttribute("tabindex", "1");
    document.body.focus();

    document.body.removeAttribute("tabindex");
    document.getElementById("app").scrollTop = 0;
  },
  watch: {

  },
  methods: {
    ...mapActions({
      getGuestVerifyMfa : COMMONS.GUEST_VERIFY_MFA_REQUEST,
      getGuestSendMfaRequest : COMMONS.GUEST_SEND_MFA_REQUEST,
    }),

    validateOtp(val) {
      this.errPhone='';
      this.errEmail='';
      if(val == 'Phone') {
        if(this.otpPhone !=null && this.otpPhone !='') {
          this.phoneCount = this.phoneCount+1;
          let data = {
          mfaType: 1,
          verificationCode: this.otpPhone,
          attemptValue: this.phoneCount
        }
          this.getGuestVerifyMfa(data);
        }else {
          this.errPhone = 'Login code is required'
        }
      } 
      else {
        if(this.otpEmail !=null && this.otpEmail !='') {
          this.emailCount = this.emailCount+1;
          let data = {
            mfaType: 2,
            verificationCode: this.otpEmail,
            attemptValue: this.emailCount
          }
        this.getGuestVerifyMfa(data);
        }
        else {
          this.errEmail = 'Login code is required'
        }
      } 
    },

    resendOtp(val) {
      this.errPhone='';
      this.errEmail='';
      this.emailCount = 0;
      this.phoneCount = 0;
      let data = {};
      if(val == 'Email') {
        this.otpEmail = '';
        data.resendOtp = true;
        data.email = this.updateContactInfo && this.updateContactInfo.email;
        data.phone = ''
      }
      if(val == 'Phone') {
        this.otpPhone = '';
        data.resendOtp = true;
        data.email = ''
        data.phone = this.formatPhoneForRims(this.updateContactInfo && this.updateContactInfo.phone);
      }
      this.getGuestSendMfaRequest(data);
    },

    async handleRouting(info) {
      if(info=='previous') {
        this.$store.state.guestLogin.contactUpdateStep = 2;
        this.$store.state.networkResponse = null;
      }
      else if (info=='next') {
        this.$router.push({name : 'Profile'})
      }
    },
  }
}
</script>

<style lang="scss" scoped>
.user-con-validate {
  display: flex;
  gap: 2rem;
  margin: 2rem 0rem;
  .user-con-details {
    display: flex;
    gap: 4rem;
    width: 50%;
    .user-details{
      width: 50%;
      .verify-updateContact{
        display: flex;
        width: 335px;
        label {
          word-wrap: break-word;
          width: 100%;
        }
        .verify-icon{
          width: 50px;
          height: 20px;
          margin-left: 5px;
        }
      }
      input {
        width: 200px;
      }
      .user-phone-details{
        display: flex;
        align-items: baseline;
        width: 335px;
        .user-phone-text{
          margin-left: 5px;
          display: flex;
          font-weight: 300;
          @media only screen and (max-width: 900px) {
            word-wrap: nowrap;
          }
        }
      }
      .err-msg{
        color: var(--ri-red);
      }
    }
    @media only screen and (max-width: 699px) {
      display: block;
      .user-details{
        width: 50px;
        .verify-updateContact{
          width: 300px;
        }
        .login-code-text{
          width: 100px;
        }
      }
    }

    @media only screen and (min-width: 700px) and (max-width: 1250px) {
      .user-details{
        .verify-updateContact {
          label {
            width: 200px;
          }
        }
        .user-phone-details {
          width: 200px;
        }
      }
    }
    @media only screen and (min-width: 900px) and (max-width: 1215px) {
      .user-details{
        input {
          width: 145px;
        }
      }
    }
  }
  .user-response {
    margin-top: 2rem;
    display: flex;
    .btn-otp{
      button {
        margin-right: 2rem;
      }
      .resend-code{
        background-color: white;
        color: var(--ri-blue);

        &:hover{
          background-color: var(--ri-lighter-blue)
        }
      }
    }
    @media only screen and (max-width: 899px) {
      .btn-otp{
        .app-btn-primary {
          margin-bottom: 1rem;
        }
      }
    }
    @media only screen and (min-width: 900px) and (max-width: 1160px) {
      display: flex;
      .btn-otp{
        display: flex;
        flex-wrap: wrap;
        gap: 1rem;
        button {
          margin-right: 2rem;
          min-width: 207px;
        }
      }
    }
  }
  @media only screen and (max-width: 899px) {
    display: block;
  }
}
.err-email{
  color: var(--ri-red);
}
.err-phone{
  color: var(--ri-red);
}
</style>  